import '../index.css';

function Privacy() {
  return (
    <div className="privacy-page">
      <div className="privacy-container">
        <h1 className="privacy-title">Política de Privacidade - Mestre do Lovable Ilimitado</h1>
        <p className="privacy-update">Última atualização: 06 de março de 2026</p>

        <section className="privacy-section">
          <h2>1. Introdução</h2>
          <p>Esta Política de Privacidade descreve como a extensão Mestre do Lovable Ilimitado coleta, usa e compartilha informações ao ser utilizada no navegador Google Chrome. Nosso compromisso é garantir a transparência e a segurança dos seus dados enquanto você otimiza sua experiência na plataforma Lovable.dev.</p>
        </section>

        <section className="privacy-section">
          <h2>2. Coleta de Dados</h2>
          <p>Para o funcionamento correto das funcionalidades de "Prompts Ilimitados", a extensão interage com os seguintes dados:</p>
          <ul>
            <li><strong>Informações de Autenticação:</strong> Podemos processar tokens de sessão estritamente para validar o acesso ao pacote de recursos ilimitados.</li>
            <li><strong>Conteúdo do Site:</strong> A extensão acessa o DOM (Document Object Model) das páginas sob o domínio lovable.dev para ajustar a interface e gerenciar o envio de prompts.</li>
            <li><strong>Atividade de Uso:</strong> Coletamos dados técnicos anônimos sobre a interação com as ferramentas da extensão para fins de depuração e melhoria de performance.</li>
          </ul>
        </section>

        <section className="privacy-section">
          <h2>3. Uso de Permissões</h2>
          <p>Justificamos o uso das seguintes permissões técnicas:</p>
          <ul>
            <li><strong>Storage:</strong> Para salvar suas preferências de configuração localmente.</li>
            <li><strong>Scripting & Host Permissions:</strong> Para injetar a lógica necessária que permite o uso contínuo da plataforma Lovable.</li>
            <li><strong>Web Request:</strong> Para garantir que as requisições de prompts sejam processadas sem interrupções de limites de interface.</li>
          </ul>
        </section>

        <section className="privacy-section">
          <h2>4. Código Remoto</h2>
          <p>Informamos que esta extensão pode carregar scripts remotos. Esses scripts são utilizados exclusivamente para manter a compatibilidade com as atualizações frequentes na API e na interface da plataforma Lovable.dev, garantindo que o serviço contratado não seja interrompido.</p>
        </section>

        <section className="privacy-section">
          <h2>5. Compartilhamento de Dados</h2>
          <p>Nós não vendemos, alugamos ou compartilhamos seus dados pessoais com terceiros. Os dados processados pela extensão são utilizados única e exclusivamente para cumprir o propósito de oferecer prompts ilimitados na plataforma Lovable.</p>
        </section>

        <section className="privacy-section">
          <h2>6. Segurança</h2>
          <p>Empregamos medidas de segurança padrão da indústria para proteger as informações processadas. Nenhum dado sensível de pagamento ou senhas pessoais do usuário é armazenado por nossa extensão.</p>
        </section>

        <section className="privacy-section">
          <h2>7. Contato</h2>
          <p>Se você tiver dúvidas sobre esta política, entre em contato através do nosso canal de suporte ao desenvolvedor.</p>
        </section>

        <div className="privacy-back">
          <a href="/" className="privacy-back-link">← Voltar para a página inicial</a>
        </div>
      </div>
    </div>
  );
}

export default Privacy;
